export default __webpack_public_path__ + "static/6837-a797229a2ac5768e9090055a217156dd.jpg";